/**
 * Extrai a mensagem de erro de uma resposta da API.
 * - Se for status 500+, retorna uma mensagem genérica de erro interno.
 * - Caso contrário, tenta usar a mensagem retornada pelo backend.
 * - Se não houver mensagem do backend, usa o fallback fornecido.
 *
 * @param {Error} error - O erro capturado no catch
 * @param {string} fallbackMessage - Mensagem padrão caso o backend não retorne uma
 * @returns {string} A mensagem de erro para exibir ao usuário
 */
export function getApiErrorMessage(error, fallbackMessage = 'Ocorreu um erro inesperado. Tente novamente.') {
  if (error?.response?.status >= 500) {
    return 'Ocorreu um erro interno no servidor. Tente novamente mais tarde.';
  }

  return error?.response?.data?.message || fallbackMessage;
}
